module Environments {
    module.factory("EnvironmentsService", [
        "$rootScope", "$http", "BootstrapDataService",
        function ($rootScope, $http, bootstrapDataService: IEnvironmentBootstrapDataService) {
            var requestCallback = function(response) {
                return response.data.success ? response.data : false;
            };

            // This cache is populated when populateEnvCache() is called from ui-router's resolve.
            var envCache = [];
            var all = function () {
                return envCache;
            };

            var populateEnvCache = function () {
                // Returns a promise to ui-router's resolve.
                // Controllers are executed only after this promise is complete -- the promise that the data is populated.
                return $http.get(bootstrapDataService.getEnvironmentsUrl).then(function (response) {
                    if (response.data.success) {
                        envCache = response.data.data;
                        return envCache;
                    }
                });
            };

            var save = function (env) {
                var postData = {
                    id: env.id,
                    name: env.name,
                    connectionString: env.connectionString,
                    configurationJson: env.configJson
                };

                return $http.post(bootstrapDataService.saveEnvironmentUrl, postData).then(requestCallback);
            };
            var saveAgentGroup = function (agentGroup: IAgentGroup, environment: IEnvironment) {
                var postData = {
                    id: agentGroup.id,
                    name: agentGroup.name,
                    configurationJson: agentGroup.configurationJson,
                    connectionString: agentGroup.connectionString,
                    environmentId: environment.id
                };

                return $http.post(bootstrapDataService.saveAgentGroupUrl, postData).then(requestCallback);
            };

            var remove = function (env) {
                var postData = { id: env.id };
                return $http.post(bootstrapDataService.removeEnvironmentUrl, postData).then(requestCallback);
            };

            var removeAgentGroup = function(agentGroup) {
                var postData = { id: agentGroup.id };
                return $http.post(bootstrapDataService.removeAgentGroupUrl, postData).then(requestCallback);
            }

            var createTemporaryEnv = function () : IEnvironment {
                return {
                    id: -1,
                    name: "",
                    agentGroups: [],
                    isNew: true
                };
            };

            var createTemporaryAgentGroup = function(): IAgentGroup {
                return {
                    executionAgents: [],
                    gatewayAgents: [],
                    id: -1,
                    isFarm: false,
                    connectionString: "",
                    configurationJson: "{}",
                    isNew: true,
                    name: ""
                };
            }

            var validateConnectionString = function (connectionString) {
                return $http.post(bootstrapDataService.validateConnectionStringUrl, { connectionString: connectionString }).then(function (response) {
                    return response.data.data;
                });
            };

            var synchronizeAgents = function(agentGroup) {
                var postData = { groupId: agentGroup.id};
                return $http.post(bootstrapDataService.resynchronizeAgentsUrl, postData).then(requestCallback);
            }

            return <IEnvironmentsService>{
                populateEnvCache: populateEnvCache,
                all: all,
                save: save,
                remove: remove,
                removeAgentGroup: removeAgentGroup,
                createTemporaryEnv: createTemporaryEnv,
                createTemporaryAgentGroup: createTemporaryAgentGroup,
                validateConnectionString: validateConnectionString,
                synchronizeAgents: synchronizeAgents,
                saveAgentGroup: saveAgentGroup
            };
        }
    ]);
    interface IEnvironmentBootstrapDataService {
        resynchronizeAgentsUrl: string;
        validateConnectionStringUrl: string;
        removeAgentGroupUrl: string;
        removeEnvironmentUrl: string;
        saveAgentGroupUrl: string;
        saveEnvironmentUrl: string;
        getEnvironmentsUrl: string;
    }
}